<template>
    <div>
        <v-expand-transition mode="out-in">
            <div v-if="loading" class="grey--text">
                <v-progress-circular :indeterminate="loading" size="18"></v-progress-circular>
            </div>
        </v-expand-transition>
    </div>
</template>

<script>
  export default {
    props: {
      loading: {type: Boolean, value: false}
    },
    name: 'LoadingProgressBar'
  }
</script>

<style scoped>

</style>
